import script from "./bonusomat-board-completed.vue?vue&type=script&lang=ts&setup=true"
export * from "./bonusomat-board-completed.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__